<template>
  <b-modal
    id="vr-modal"
    centered
    body-class="vr-modal-body"
    content-class="vr-modal-content"
    :hide-footer="true"
    v-if="selectedSeatView"
    @hidden="onHidden"
    @show="onShow"
  >
<!--  -->
    <!-- <template v-slot:modal-header="{ close }">
      <div class="vr-modal-header">
        <div class="row-buttons">
          <div
            v-for="(seatView, index) in availableSeatViews"
            :key="index"
            @click="() => (selectedSeatView = seatView)"
            :class="`row-button ${
              selectedSeatView.rowPath === seatView.rowPath ? 'selected' : ''
            }`"
          >
            <span>{{ seatView.rowName }}</span>
          </div>
        </div>
        <div class="close-modal-btn" @click="close()">
          <span>Close View</span>
          <img :src="require('@/assets/images/icons/close.svg')" />
        </div>
      </div>
    </template> -->
    <div class="modal-body-content">
		<div class="vr-modal-header">
          <div class="row-buttons">
            <div
              v-for="(seatView, index) in availableSeatViews"
              :key="index"
              @click="() => (selectedSeatView = seatView)"
              :class="`row-button ${
                selectedSeatView.rowPath === seatView.rowPath ? 'selected' : ''
              }`"
            >
              <span>{{ seatView.rowName }}</span>
            </div>
          </div>
          <!-- <div class="close-modal-btn" @click="close()">
            <span>Close View</span>
            <img :src="require('@/assets/images/icons/close.svg')" />
          </div> -->
        </div>
      <iframe
        id="vr-iframe"
        :src="`${seatViewsPrefix}/${selectedSeatView.rowPath}/index.html`"
      />
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "VRModal",
  props: {
    availableSeatViews: {
      type: Array,
      required: true,
    },
  },
  watch: {
    availableSeatViews: function (newVal) {
      this.selectedSeatView = newVal[0];
    },
  },
  data() {
    return {
      seatViewsPrefix: process.env.VUE_APP_SEAT_VIEWS_LOCATION,
      selectedSeatView: null,
    };
  },
  mounted() {
    this.selectedSeatView = this.availableSeatViews[0];
  },
  methods: {
    onHidden() {
      document.documentElement.style.overflow = "auto";
    },
    onShow() {
      document.documentElement.style.overflow = "hidden";
    },

  },
};
</script>


<style lang="scss">
#vr-modal {
  background: rgba(0, 0, 0, 0.3);

  .modal-header {
    border-bottom: none;
    padding: 0;
  }
  .btn-close{

	  background: transparent url("~images/close.svg");
	  background-repeat:no-repeat;
	  background-size:cover;
	  opacity:1;
	  width:10px;
	  height:10px;
	  position: absolute;
	  top: -5px;
	  right: 175px;
	  z-index: 100;
	  @include media-breakpoint-down(sm) {
		   right: 15px;
		   top: 15px;
	  }
  }
  .vr-modal-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background: transparent;
    width: 100%;
    padding: 0 12.5vw;
    img {
      height: 15px;
      width: 15px;
      cursor: pointer;
    }
  }
  .row-buttons {
    display: flex;
    flex-direction: row;
    align-content: center;
    .row-button {
      height: 40px;
      width: 210px;
      max-width: 30vw;
      flex: 1;
      background-color: #959595;
      position: relative;
      cursor: pointer;
	  font-family: "GeogrotesqueSharp-Md";
      margin-right: 4px;
      span {
        // font-family: "Neutra2Display-Titling";
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0.2px;
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .selected {
      background-color: #f16924;
    }
  }

  .modal-body-content {
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;
	flex-direction:column;
    justify-content: center;
    align-items: center;
  }
  .vr-modal-body {
    height: 80vh;
    width: 100vw;
    padding: 0;

    #vr-iframe {
      height: 100%;
      width: 75vw;
      border: none;
    }
  }
  .modal-dialog {
    width: 100vw;
    height: 100vh;
    margin: 0;
  }
  .vr-modal-content {
    background: transparent;
    border: none;
    width: 100vw;
  }
  // @media (max-width: $xxl) {
  //   #vr-iframe {
  //     width: 90vw !important;
  //   }
  //   .vr-modal-header {
  //     padding: 0 5vw;
  //   }
  // }
  // @media (max-width: $lg) {
  //   #vr-iframe {
  //     width: 100vw !important;
  //   }
  //   .vr-modal-header {
  //     padding: 0;
  //   }
  // }
}
.close-modal-btn {
  height: 40px;
  width: 151px;
  // background-color: $orange;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  span {
	  font-family: "GeogrotesqueSharp-Md";
	// font-family: "Neutra2Display-Titling";
	font-size: 14px;
	color: #ffffff;
	letter-spacing: 0.2px;
	text-align: start;
	transform: translateY(2px);
  }
}
</style>
